<template>
  <div class="box-root">
    <div class="box-header">Supporting Documents</div>
    <div class="document-group">
      <div class="box" v-for="(f, key) in files" :key="key">
        <div class="blank" v-if="!f.model">
          <i class="far fa-eye-slash blank-icon"></i>
        </div>
        <img
          v-else
          @click="openFile(f.model)"
          class="img"
          :src="`${f.model}?${new Date().getTime()}`"
        />
        <div class="box-footer">
          <div class="loader" v-if="isUploading"></div>
          <template v-else>
            <label :for="f.id" class="uploader">
              <i class="fa fa-upload"></i>
              {{ `Upload ${f.text}` }}
            </label>
            <input
              :id="f.id"
              style="display:none;"
              type="file"
              accept="application/pdf, image/*"
              @change="uploadFile($event.target.files[0], f.id)"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../digilib_web/core/digitify';

export default {
  props: {
    id: Number,
    profile: Object
  },
  methods: {
    reload() {
      // hardcode get ktp and passport urls only for now
      if (this.id >= 0) {
        http
          .get(`employees/${this.id}?select=ktp_url,passport_url,doc_url`)
          .then(json => {
            let data = json.data;
            for (let k in data) {
              this.files[k].model = data[k];
            }
          });
      }
    },
    openFile(url) {
      window.open(url, '_blank');
    },
    uploadFile(file, key) {
      if (file) {
        // limit the file size to 2 mb for now
        if (file.size > 2000000) {
          alert(`File size can't be more than 2 mb`);
          return;
        }
        this.isUploading = true;
        let formData = new FormData();
        formData.append('file', file);
        let id = this.id;
        let endpoint = `employees/${id}/${key}`;
        http.post(endpoint, formData).then(json => {
          this.isUploading = false;
          if (json.success) {
            alert('File Uploaded successfully!');
            this.reload();
          } else {
            alert('Something went wrong, please upload again');
          }
        });
      }
    }
  },
  mounted() {
    this.reload();
  },
  data() {
    return {
      notif: null,
      isUploading: false,
      files: {
        ktp_url: { id: 'ktp', text: 'Doc 1', model: null },
        passport_url: { id: 'passport', text: 'Doc 2', model: null },
        doc_url: { id: 'doc', text: 'Doc 3', model: null }
      }
    };
  }
};
</script>

<style scoped>
.uploader {
  padding: 5px;
  color: #39a2d9;
  cursor: pointer;
  text-transform: uppercase;
}
.box-root {
  display: flex;
  flex-flow: column;
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  margin-bottom: 10px;
}
.box-header {
  background-color: #f7f8f7;
  font-size: 1rem;
  padding: 10px;
  font-weight: bold;
  line-height: 1.1;
  text-transform: uppercase;
}
.document-group {
  display: flex;
  justify-content: space-between;
}
.box {
  padding: 10px;
  display: flex;
  flex-flow: column;
  flex: 1;
}
.box-footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img {
  width: 100%;
  min-height: 300px;
  max-height: 300px;
  cursor: pointer;
}
.blank {
  flex: 1 1 auto;
  background-color: #f7f8f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
}
.blank-icon {
  color: rgb(203, 205, 205);
  font-size: 5em;
}
@media screen and (max-width: 768px) {
  .document-group {
    flex-flow: column;
  }
  .box-root {
    margin-bottom: 5px;
  }
  .img {
    min-height: auto;
    height: 150px;
  }
  .blank {
    padding: 25px;
    height: 150px;
  }
}
</style>
